import React from "react";
import CountUp from "react-countup";

const ChiffreContent = ({ chiffre }) => {
    const chiffres = chiffre && [...chiffre];
    return (
        chiffres && chiffres.map((res, index) => {
            return (
                <div key={index} className="chiffre-content">
                    <div className="icon">
                    {
                                    res.icon?.data?.attributes && <img src={`${process.env.GATSBY_API_URL_FILE}`+res.icon.data.attributes.url} alt={res.name} />
                                }
                    </div>
                    <div className="text">
                        <span>+{res.chiffre} {res.unite}</span>
                        <p> {res.sous_titre}</p>
                    </div>
                </div>
            )

        })

    )
}

export default ChiffreContent;